"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useApiService = void 0;
const ResponseHelper_1 = require("./ResponseHelper");
const UserApiService_1 = __importDefault(require("./UserApiService"));
const userService = new UserApiService_1.default();
/**
 * A custom hook that provides an API service for making HTTP requests.
 * @returns An object containing the userService and handleResponse functions.
 */
const useApiService = () => {
    const handleResponse = (response, successHandler, errorHandler) => {
        return (0, ResponseHelper_1.extractResponseData)(response, successHandler, errorHandler);
    };
    return { userService, handleResponse };
};
exports.useApiService = useApiService;
